import asyncSessionLoader from "../../../gd/data/async-session-loader"
import FinderTasksCollection from "../../../model2/task/finder/collection"

const debug = false
// const debug = "finderLoadRecentTasks"

export function finderLoadRecentTasks(excludedTasksIds: ID[] = []): Promise<FinderTasksCollection> {
    debug && console.log(debug, 'process')

    return new Promise(async (resolve, reject) => {
        const sortedRecentTaskIds = _(gd.session.recent.tasks.getSorted().models)
            .filter(((r:any)=>!r.title))
            .map((r:any)=>r.taskId)
            .value()
        const response = await gd.api.MyWork.getRecentTasks(sortedRecentTaskIds).promise()

        const data  = _.filter(response, t=>!excludedTasksIds.includes(t.id))

        await asyncSessionLoader(findMissingData(data))
        const collection:FinderTasksCollection  = FinderTasksCollection.initFromJson(data)

        debug && console.log(debug, 'loadedData', collection)

        resolve(collection)
    })
}

function findMissingData(tasks: any[]) {
    if (!tasks) return false
    let uniqueTaskTypes = _.uniq(_.map(tasks, 'taskTypeId'))

    return gd.session.findMissing({
        taskTypes: uniqueTaskTypes
    })
}